var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "current"
    },
    d: "M87.4,29.8C85.8,14,72.4,1.6,56.1,1.6H45.3c-17.4,0-31.5,14.1-31.5,31.5v27.4h2.1c6.3,0,11.4,5.1,11.4,11.4 c0,2.5-0.9,4.8-2.3,6.7h4.2c6.3,0,11.4,5.1,11.4,11.4c0,2.6-1,5.1-2.5,7c14.5,4.6,29.3-1.5,29.3-1.5c11.8-4.5,20.2-16,20.2-29.4 l0,0c0-2.3-1.8-4.1-4.1-4.1H67.3c-2.3,0-4.1,1.8-4.1,4.1l0,0c0,3.9-3.2,7.1-7.1,7.1H45.3c-3.9,0-7.1-3.2-7.1-7.1v-33 c0-3.9,3.2-7.1,7.1-7.1h6.8c2.1,0,3.8,1.7,3.8,3.8v15c0,3.3,2.2,6.4,5.5,7c4.4,0.9,8.2-2.5,8.2-6.7v-5.8c0-1.2,1-2.2,2.2-2.2 c1.2,0,2.2,1,2.2,2.2v1.2c0,3.3,2.2,6.4,5.5,7c4.4,0.9,8.2-2.5,8.2-6.7v-3.6v-4.1L87.4,29.8z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.cfdff5cbbef81ba19386d3ef5fbce5ef.svg";
export { ForwardRef as ReactComponent };